import { CustomTextAreaNoForm, CustomTextFieldNoForm, TabTextLabel } from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { Button, Grid } from "@mui/material"
import { Visibility } from "@mui/icons-material";
import { useState } from "react";
import { gridSizeMdLg12 } from "@/shared";

type InfoObservacionesProps = {
  label:string;
  contentText?:string;
  fechaMod?:string;
}
export default function InfoObservaciones({ label="Observaciones", contentText, fechaMod }: InfoObservacionesProps) {

  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        color="primary"
        endIcon={<Visibility />}
        onClick={() => {
          setOpen(true)
        }}
      >
        Ver
      </Button>
      {
        open && (
          <ScrollableDialogProps
            onCloseIcon={() => setOpen(false)}
            open={open}
            title="Observaciones"
            minWidth="48%"
            contentNode={
              <Grid container spacing={3}>
                <TabTextLabel
                  text={label}
                />
                <CustomTextAreaNoForm
                  disabled={true}
                  label={`Observaciones`}
                  value={contentText|| ""}
                  defaultValue={contentText}
                  size={gridSizeMdLg12}
                />
                
                <CustomTextFieldNoForm
                  disabled={true}
                  label={`Fecha`}
                  value={fechaMod || ""}
                  defaultValue={fechaMod || ""}
                  size={gridSizeMdLg12}
                />
                
              </Grid>
            }
          />
        )
      }
    </>
  )
}